import { BALANCE_CONSISTENCY_CHECK_CODES } from '@constants/consistency-check/balance-consistency-check.constant';
import { DEFAULT_DEBIT_BANK_ACCOUNT_NOT_CONFIGURED } from '@constants/consistency-check/bank-accounts-consistency-check.constant';
import { IMMOBILISATION_CONSISTENCY_CHECK_CODES } from '@constants/consistency-check/immobilisation-consistency-check.constant';
import { LABEL_CONSISTENCY_CHECK_CODES } from '@constants/consistency-check/label-consistency-check.constant';
import { PCG_ENTRY_CONSISTENCY_CHECK_CODES } from '@constants/consistency-check/pcg-entry-consistency-check.constant';
import {
  MISSING_INFORMATION,
  UNBALANCED_SHARES_NUMBER
} from '@constants/consistency-check/person-consistency-check.constant';
import { TNS_CONSISTENCY_CHECKS_CODES } from '@constants/consistency-check/tns-consistency-check.constant';
import { TRANSACTIONS_VAT_DIFFERENCE } from '@constants/consistency-check/transaction-consistency-check.constant';
import { VAT_DECLARATION_CONSISTENCY_CHECK_CODES_WITH_DETAILS } from '@constants/consistency-check/vat-declaration-consistency-check.constant';

export type VerboseConsistencyCheckStatus = 'error' | 'warning' | 'ok';

export interface VerboseConsistencyCheckJson {
  code: string;
  description: string;
  status: VerboseConsistencyCheckStatus;
  order?: number;
  data?: any;
  has_details?: boolean;
}

export class VerboseConsistencyCheck {
  hasAction = false;

  constructor(
    public code?: string,
    public description?: string,
    public status?: VerboseConsistencyCheckStatus,
    public order?: number,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    public data?: any,
    public hasDetails?: boolean
  ) {
    this.hasAction = hasDetails || VerboseConsistencyCheck.verboseConsistencyCheckHasAction(code);
  }

  /**
   *
   * @param {VerboseConsistencyCheckJson} json
   * @param {boolean} enableHasDetails Permet de désactiver le champ `hasDetails` utiliser seulement la méthode `verboseConsistencyCheckHasAction` pour calculer le champ `hasAction`
   * @returns {VerboseConsistencyCheck}
   */
  static fromJson(json: VerboseConsistencyCheckJson, enableHasDetails: boolean = false): VerboseConsistencyCheck {
    return new VerboseConsistencyCheck(
      json.code,
      json.description,
      json.status,
      json.order,
      json.data,
      enableHasDetails ? json.has_details : false
    );
  }

  static verboseConsistencyCheckHasAction(code: string): boolean {
    return [
      ...TNS_CONSISTENCY_CHECKS_CODES,
      ...IMMOBILISATION_CONSISTENCY_CHECK_CODES,
      ...LABEL_CONSISTENCY_CHECK_CODES,
      ...BALANCE_CONSISTENCY_CHECK_CODES,
      ...PCG_ENTRY_CONSISTENCY_CHECK_CODES,
      ...VAT_DECLARATION_CONSISTENCY_CHECK_CODES_WITH_DETAILS,
      TRANSACTIONS_VAT_DIFFERENCE,
      DEFAULT_DEBIT_BANK_ACCOUNT_NOT_CONFIGURED,
      MISSING_INFORMATION,
      UNBALANCED_SHARES_NUMBER
    ].includes(code);
  }
}
